import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import { connect } from 'react-redux';
import * as siteMaster from '~/data/actions/siteActions'; //now we can use user actions here
import i18n from '~/i18n'

//CONNECT TO STORE
@connect((store) => {
    return { user: store.user }
})

export default class removeStaff extends React.Component {
    constructor(props) {
        super(props);

        this.closeDrawer = this.closeDrawer.bind(this);
        this.confirm = this.confirm.bind(this);
    }

    closeDrawer() {
        this.props.dispatch(siteMaster.alterSiteDrawer(false, false, "right", null, true));
    }

    confirm() {
        this.closeDrawer()
        this.props.confirm(this.props.userId);
    }

    render() {

        return <div>
            <h4 className="mar-b25">{i18n.t('permissions:users.removeHeader')} {i18n.t('campaign')}?</h4>

            <div className="quickFlex">
                <Button text={i18n.t('yes')} className="button-primary mar-r10" onClick={this.confirm} />
                <Button text={i18n.t('cancel')} onClick={this.closeDrawer} />
            </div>

        </div>

    }
};


